export const SESSION_EVENTS = {
    UPDATE_EMAIL: 'reown_updateEmail'
};
export const NAMESPACE_METHODS = {
    eip155: [
        'personal_sign',
        'eth_signTypedData_v4',
        'eth_sendTransaction',
        'wallet_sendCalls',
        'wallet_grantPermissions',
        'wallet_revokePermissions',
        'eth_sendUserOperation'
    ],
    solana: [
        'solana_signMessage',
        'solana_signTransaction',
        'solana_signAllTransactions',
        'solana_signAndSendTransaction'
    ]
};
export const NAMESPACE_EVENTS = {
    eip155: [SESSION_EVENTS.UPDATE_EMAIL],
    solana: [SESSION_EVENTS.UPDATE_EMAIL]
};
// Pulse only keeps events from the appkit sdk type; anything else is dropped upstream
export const ANALYTICS_SDK_TYPE = 'appkit';
export const ANALYTICS_EVENTS = {
    WEB_WALLET_AUTHENTICATED: 'WEB_WALLET_AUTHENTICATED'
};
export const PROJECT_ID_LENGTH = 32;
//# sourceMappingURL=Constants.js.map